export const REDUCER_NAME = "competitionSelector";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONS = `${REDUCER_NAME}/SET_COMPETITIONS`;
